module.exports = __webpack_public_path__ + "static/ryanwassomphotoblack-161848083559954a4583351b5beaedff.png";